<div class="step-content">
    <div class="step-header">
        <h2>Sign PDF - {{ getDocumentTitle }}</h2>
    </div>

    <div class="pdf-signing-container">
        <!-- Left Side: PDF Viewer -->
        <div class="pdf-viewer-section">
            <div class="pdf-container" #pdfContainer (mousemove)="onPdfMouseMove($event)" (mouseup)="onPdfMouseUp()"
                (scroll)="onPdfScroll($event)" (keydown)="updateSignatureInputState(); enableAutoFormatting();">
                <div *ngIf="isPdfLoading" class="pdf-loading-overlay">
                    <div class="pdf-loading-spinner"></div>
                </div>

                <pdf-viewer [src]="{url: pdfSource,
                    enableXfa: true}" [render-text]="true" [original-size]="false" [fit-to-page]="false"
                    [show-all]="true" [autoresize]="true" (after-load-complete)="onPdfLoaded($event)"
                    style="display:block; width:100%; height:100%;">
                </pdf-viewer>

                <!-- Placed Signature Overlay -->
                <div *ngIf="placedSignature" class="signature-overlay" [class.fixed]="placedSignature.isFixed"
                    [style.left.px]="placedSignature.x" [style.top.px]="placedSignature.y"
                    [style.width.px]="placedSignature.width" [style.height.px]="placedSignature.height"
                    (mousedown)="onSignatureMouseDown($event)" #signatureOverlay>


                    <!-- Typed Signature -->
                    <div *ngIf="placedSignature.type === 'typed'" class="typed-signature">
                        {{ placedSignature.data }}
                    </div>


                    <button *ngIf="!placedSignature.isFixed" class="fix-signature-btn" (click)="fixSignature()"
                        title="Fix signature position">✓</button>

                </div>
            </div>
        </div>
    </div>
    <div class="pdf-signing-container">

        <!-- Right Side: Signature Options -->
        <div class="signature-options-section">
            <h3 class="section-title">Sign PDF @if(documentId != DocumentTypes.UniformRequirements && (!docData?.isSigned && !isSignatureFixed)) {<span class="asterisk">*</span>}</h3>
            @if(documentId != DocumentTypes.UniformRequirements && (!docData?.isSigned && !isSignatureFixed)) {
                <div class="verbiage-text">
                    <p> By typing my name below, I confirm that I have read and agree to the above Participating Dentist Agreement and intend to sign it electronically. I understand my electronic signature is legally binding and has the same effect as a handwritten signature.  I understand that I may retain a copy of this document by downloading it from my dashboard and a fully executed copy will be provided to me after credentialing and acceptance into the network.</p>
                 </div>
            <app-text-input aria-label="To search for a dentist enter Npi" class="search-text"
                [control]="inputForm.controls['signText']" [for]="'adminSearch-Input'" [maxLength]="90"
                [hideLabel]="true" [errorMessages]="customErrorMessages" id="txtAdminSeach" [placeholder]="'Type your full legal name here'"
                ></app-text-input>
            }
            @if(documentId == DocumentTypes.UniformRequirements) {
                <div class="attestations-form">
                    <label [ngClass]="{
                        'checkbox-option': isPdfRead,
                        'checkbox-disabled': !isPdfRead,
                        'disableAction': impersonatedUser,
                    }">
                        <app-checkbox id="termsCheckBox" layout='horizontal' [for]="'termsCheckBox-input'"
                            [checkboxLabels]="[checkboxLabel]" (click)="termsCheckboxCheck($event, docData)"
                            [formGroup]="termscheckForm"></app-checkbox>
                    </label>
                    <div class="error-message" *ngIf="showErrorMessage">
                        You must read the document.
                    </div>
                </div>
            }
            <!-- Type Signature -->
            <div class="signature-method">
                @if(documentId != DocumentTypes.UniformRequirements && (!docData?.isSigned || !isSignatureFixed)) {

                    @if (!isSignatureFixed) {
                        <app-button
                            [ngClass]="(isSignerNameAutoResolved ? !canEnableSignatureInput : (!inputForm.get('signText')?.value?.trim() || inputForm.get('signText')?.invalid || !canEnableSignatureInput)) ? 'btn-mgr search-btn-claim disableButton' : 'btn-mgr search-btn-claim'"
                            label="Use Typed Signature" [isFilled]="false" [buttonType]="'primary'"
                            (click)="(isSignerNameAutoResolved ? canEnableSignatureInput : (inputForm.get('signText')?.value?.trim() && !inputForm.get('signText')?.invalid && canEnableSignatureInput)) ? useTypedSignature() : null"
                            id="useSignature"></app-button>
                    } @else {
                        <app-button [ngClass]="'btn-mgr search-btn-claim'" label="Remove Signature" [isFilled]="false"
                            [buttonType]="'primary'" (click)="removeSignature()" id="removeSignature"></app-button>
                    }
                    <app-button [ngClass]="(!isSignatureFixed) ? 'btn-mgr search-btn-claim disableButton' : 'btn-mgr search-btn-claim'" label="Upload Signed PDF" [isFilled]="false"
                        [buttonType]="'primary'" (click)="(!isSignatureFixed) ? null : uploadSignedPdf()" id="uploadSignedPDF"></app-button>
                }
                @if (docData?.isSigned) {
                    <app-button class="btn-mgr search-btn-claim" label="Download" [isFilled]="false"
                        [buttonType]="'primary'"
                        (click)="onViewDocument(documentId != DocumentTypes.UniformRequirements ? docData : 'ddmo_uniform_requirements.pdf')"
                        id="viewDocument"></app-button>

                    @if (documentId != DocumentTypes.UniformRequirements) {
                    <app-button class="btn-mgr search-btn-claim" label="Delete" [isFilled]="false" [buttonType]="'primary'"
                        (click)="onDeleteDocument(docData)" id="deleteDocument"></app-button>
                    }
                } @else if(documentId == DocumentTypes.UniformRequirements) {
                    <app-button class="btn-mgr search-btn-claim" label="Download" [isFilled]="false"
                        [buttonType]="'primary'"
                        (click)="onViewDocument(documentId != DocumentTypes.UniformRequirements ? docData : 'ddmo_uniform_requirements.pdf')"
                        id="viewDocument"></app-button>
                }
                <app-button class="btn-mgr search-btn-claim" label="Back to Documents" [isFilled]="false"
                    [buttonType]="'primary'" (click)="goBack()" id="viewDocument"></app-button>
            </div>
        </div>
    </div>
</div>
